var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('GlobalNotify',{attrs:{"info":_vm.notifyInfo,"visible":_vm.notifyVisible}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }